import React, { Component } from "react";
import classnames from "classnames";
import Intercom, { IntercomAPI } from "react-intercom";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import Loading from "../Loading/Loading";
import Header from "../Header/Header";
import ModalDeclarations from "../modals/ModalDeclarations/ModalDeclarations";

import "./App.css";

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_ID;

class App extends Component {
  constructor(props) {
    super(props);

    this.intercomUser = {};
  }

  componentWillReceiveProps(nextProps) {
    // update Intercom if the path changes
    if (
      nextProps.location &&
      nextProps.location.pathname !== this.props.location.pathname
    ) {
      IntercomAPI("update");
    }

    // update Intercom if the user id updates
    const { profile } = nextProps.user;
    if (profile.id && profile.id !== this.props.user.profile.id) {
      this.intercomUser.user_id = profile.id;
      this.intercomUser.email = profile.email;
      this.intercomUser.name = profile.name;

      IntercomAPI("update", { ...this.intercomUser });
    }
  }

  isFullHeightPage = () => {
    const { pathname } = this.props.location;
    return (
      pathname.indexOf("/register") !== -1 ||
      pathname.indexOf("signup-details") !== -1 ||
      pathname.indexOf("/login") !== -1 ||
      pathname.indexOf("/forgot") !== -1 ||
      pathname.indexOf("/reset") !== -1 ||
      pathname.indexOf("/reactivate") !== -1 ||
      pathname.indexOf("/payment-failure") !== -1 ||
      pathname.indexOf("/start") !== -1 ||
      pathname.indexOf("/success") !== -1
    );
  };

  isWhiteBgPage = () => {
    const { pathname } = this.props.location;
    return pathname.indexOf("/activate") !== -1;
  };

  isDefaultBgPage = () => {
    const { pathname } = this.props.location;
    return pathname.indexOf("signup-details") !== -1;
  };

  isNewDesign = () => {
    const { pathname } = this.props.location;
    return (
      pathname.indexOf("signup-details") !== -1 ||
      pathname.indexOf("/activate") !== -1 ||
      pathname.indexOf("/offer-47") !== -1 ||
      pathname.indexOf("/offer-lang7") !== -1 ||
      pathname.indexOf("/start") !== -1 ||
      pathname.indexOf("/plans-and-billing") !== -1
    );
  };

  isVerticalCenterPage = () => {
    const { pathname } = this.props.location;
    return (
      pathname.indexOf("/register") !== -1 ||
      pathname.indexOf("signup-details") !== -1 ||
      pathname.indexOf("/login") !== -1 ||
      pathname.indexOf("/forgot") !== -1 ||
      pathname.indexOf("/reset") !== -1 ||
      pathname.indexOf("/reactivate") !== -1 ||
      pathname.indexOf("/payment-failure") !== -1 ||
      pathname.indexOf("/success") !== -1
    );
  };

  isSmallPage = () => {
    const { pathname } = this.props.location;
    return (
      pathname.indexOf("/forgot") !== -1 ||
      pathname.indexOf("/reset") !== -1 ||
      pathname.indexOf("/register") !== -1 ||
      pathname.indexOf("/success") !== -1      
    );
  };

  noSidePadding = () => {
    const { pathname } = this.props.location;
    return (
      pathname.indexOf("/reactivate") !== -1 ||
      pathname.indexOf("/success") !== -1
    );
  };

  signUpStepIndex = () => {
    const { pathname } = this.props.location;
    if (pathname.indexOf("/register") !== -1) {
      return 1;
    }
    if (pathname.indexOf("/activate") !== -1) {
      return 2;
    }
    if (pathname.indexOf("/offer-") !== -1) {
      return 3;
    }
    return undefined;
  };

  render() {
    const newDesign = this.isNewDesign();
    const isWhiteBg = this.isWhiteBgPage();
    const isDefaultBg = this.isDefaultBgPage();
    const isFullHeight = this.isFullHeightPage();
    const isSmall = this.isSmallPage();
    const isVerticalCenterPage = this.isVerticalCenterPage();
    const noSidePadding = this.noSidePadding();
    const signUpStepIndex = this.signUpStepIndex();
    const { children, error, reauthenticateStatus } = this.props;

    let content = null;
    if (reauthenticateStatus === "LOADING") {
      content = (
        <div className="main-content row full-height vertical-center small-content">
          <div className="col">
            <Loading />
          </div>
        </div>
      );
    } else if (reauthenticateStatus === "FAIL") {
      content = (
        <div className="main-content row full-height">
          <div className="col">
            <p className="text-danger">
              {error.message || "Please refresh again"}
            </p>
          </div>
        </div>
      );
    } else {
      content = (
        <div
          className={classnames(
            "main-content row",
            { "white-bg": isWhiteBg },
            { "default-bg": isDefaultBg },
            { "full-height": isFullHeight },
            { "small-content": isSmall },
            { "vertical-center": isVerticalCenterPage }
          )}
        >
          <div className={classnames("col", { "p-0": noSidePadding })}>
            {children}
          </div>
        </div>
      );
    }

    return (
      <div
        className={classnames("App", {
          "new-design": newDesign,
        })}
      >
        <div className="container-fluid">
          <div className="row">
            <Header signUpStepIndex={signUpStepIndex} />
          </div>
          {content}

          <Intercom appID={INTERCOM_APP_ID} {...this.intercomUser} />

          <ModalDeclarations />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    reauthenticateStatus: state.user.reauthenticateStatus,
    error: state.user.error,
  };
}

export default compose(withRouter, connect(mapStateToProps))(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js